import { renderAsync } from "docx-preview";
import { Controller } from "stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = ["spinner", "container"];

  declare readonly urlValue: string;
  declare readonly spinnerTarget: HTMLElement;
  declare readonly containerTarget: HTMLElement;

  connect() {
    this.renderDocument();
  }

  async renderDocument() {
    if (!this.urlValue) {
      this.containerTarget.innerHTML =
        "<p class='text-red-500 p-4'>Lỗi: Cannot find URL of docx file.</p>";
      this.spinnerTarget.classList.add("hidden");
      return;
    }

    try {
      const response = await fetch(this.urlValue);
      if (!response.ok)
        throw new Error(`Network response was not ok: ${response.statusText}`);

      const fileBlob = await response.blob();

      await renderAsync(fileBlob, this.containerTarget, null, {
        className: "docx-wrapper",
        experimental: true,
      });
    } catch (error) {
      console.error("Error rendering DOCX:", error);
      this.containerTarget.innerHTML = `<div class='p-4 text-center text-red-600'>Error occurred in docx display.</div>`;
    } finally {
      this.spinnerTarget.classList.add("hidden");
    }
  }
}
